import {
  Loading,
  MultiSelectWithRender,
  TruFormButton,
  useQParam,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import {
  useListLocations,
  useAssignProductDefinitionToGroup,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { GetLocationByKey } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { differenceWith } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Branch } from './branch';
import './style.scss';
export const AssignProductToBranch = () => {
  const [valid, setValid] = useState(true);
  const toaster = useToastContext();
  const productDefinitionKey = useQParam('assign-branch');
  const selectedList = useRef<GetLocationByKey[]>([]);
  const history = useHistory();
  const branches =
    (useLocation().state as { branches: string })?.branches || ' ';
  const {
    data: locations,
    loading,
    query,
    handleOffset,
    paging,
    get,
  } = useListLocations({
    select: ['key', 'name', 'address'],
    paginate: {
      limit: 20,
      offset: 0,
    },
  });

  const { data: productBranches } = useListLocations({
    select: ['key'],
    paginate: {
      limit: 50,
      offset: 0,
    },
    filter: {
      productDefinitionKeys: [productDefinitionKey!],
    },
  });
  const assignProductToBranch = useAssignProductDefinitionToGroup();
  const handleAdd = async () => {
    if (selectedList.current.length < 1) {
      setValid(false);
      return;
    }
    const payload = selectedList.current.map((item: GetLocationByKey) => ({
      productDefinitionKey: productDefinitionKey || '',
      locationKey: item.key || '',
    }));
    try {
      await assignProductToBranch({
        assigning: payload,
      });
      toaster.success('Successfully added!');
      history.replace({
        search: '',
        state: { productKey: productDefinitionKey },
      });
    } catch (error) {
      toaster.error(`Error!, please try again.`);
      get();
    }
  };
  const getAvailableBranches = () => {
    if (branches.trim()) {
      return allLocations
        ?.filter((location) => !branches.includes(location.key!!))
        .sort((first, second) => first.name!!.localeCompare(second.name!!));
    }

    return differenceWith(
      allLocations,
      productBranches as ArrayLike<GetLocationByKey>,
      (a, b) => a.key === b.key,
    ).sort((first, second) => first.name!!.localeCompare(second.name!!));
  };

  if (!productDefinitionKey) {
    history.replace({ search: '' });
    toaster.error('Error');
  }

  const offsetRef = useRef(0);
  const initialRender = useRef(true);
  const hasMore = useRef(true);

  const loadMore = () => {
    offsetRef.current += query.paginate?.limit!;
    handleOffset(offsetRef.current);
  };

  const [allLocations, setAllLocations] = useState<GetLocationByKey[]>([]);

  useEffect(() => {
    if (locations) {
      initialRender.current = false;
      setAllLocations([
        ...allLocations!!!,
        ...locations!!,
      ] as GetLocationByKey[]);
    }
    if (paging?.count! === allLocations.length) {
      hasMore.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations]);

  if (loading && !query.paginate?.offset) return <Loading />;
  return (
    <div className="add-product-branch">
      {allLocations && (
        <MultiSelectWithRender
          hasMore={hasMore}
          loadMore={loadMore}
          loader={<Loading />}
          key={productDefinitionKey}
          keyExtractor={(item) => item.key}
          label="Select one or more branch"
          onChange={(list) => {
            if (list.length > 0) {
              setValid(true);
            } else {
              setValid(false);
            }
            selectedList.current = list as GetLocationByKey[];
          }}
          data={getAvailableBranches()}
          renderItem={({ item: branch, selected }) => {
            return (
              <Branch branch={branch as GetLocationByKey} selected={selected} />
            );
          }}
        />
      )}
      <div className="controls">
        <TruFormButton type="primary" onClick={handleAdd} disabled={!valid}>
          Add
        </TruFormButton>
        <TruFormButton
          onClick={() => {
            history.replace({ search: '' });
          }}
        >
          Cancel
        </TruFormButton>
      </div>
    </div>
  );
};
